var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"words-view"},[(_vm.sliderMode)?_c('EditWordsSlider',{attrs:{"display-words-controls":_vm.displayWordsControls,"words":_vm.displayWords}}):_c('LessonWordsList',{attrs:{"words":_vm.filteredWords,"display-words-controls":_vm.displayWordsControls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }